import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGetCartPage } from '../../../url-handling'

type CartIntermediateGoToCartButtonProps = {
  className?: string
  onClick: () => void
}

export const CartIntermediateGoToCartButton: FC<
  CartIntermediateGoToCartButtonProps
> = ({ className, onClick }) => {
  const globalConfig = useGlobalConfigContext()

  return (
    <Button<'a'>
      className={className}
      data-qa-id="cart-button"
      href={urlResolverGetCartPage(globalConfig)}
      onClick={onClick}
      variant="filled"
    >
      <FormattedMessage id="general.button.label.goToCart" />
    </Button>
  )
}
